import { atob } from 'isomorphic-base64';
export function jwsDecode(token) {
    var _a = token.split('.'), payload = _a[1];
    return JSON.parse(atob(payload));
}
//# sourceMappingURL=jwsDecode.js.map